import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header, [app-header]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() hideNav = false;
  @Input() lightBackground = false;

  constructor(public userService: UserService,
              private router: Router,
              private authService: AuthService) {
  }

  ngOnInit() {
  }

  async onLoginClick() {

    if (this.authService.authToken) {
      try {
        const user = await this.userService.getSelf();
        this.router.navigate(['/admin/nasveti']);
      } catch (e) {
        this.router.navigate(['/login']);
      }
    }else{
      this.router.navigate(['/login']);
    }

  }

}
